var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.293 12.7071L10.293 19.7071C10.6835 20.0976 11.3165 20.0976 11.707 19.7071C12.0975 19.3166 12.0975 18.6836 11.707 18.2931L6.414 13.0001L20 13.0001C20.552 13.0001 21 12.5521 21 12.0001C21 11.4481 20.552 11.0001 20 11.0001L6.414 11.0001L11.707 5.70713C12.0975 5.31663 12.0975 4.68362 11.707 4.29312C11.5115 4.09762 11.256 4.00012 11 4.00012C10.744 4.00012 10.4885 4.09762 10.293 4.29312L3.293 11.2931C2.9025 11.6836 2.9025 12.3166 3.293 12.7071Z","fill":"white"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
